import type { AxiosResponse } from 'axios';

import { baseRoutes, baseRoutesV2, baseUrl } from '@/api/config';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type {
  AggrDeviceBody,
  AggrDeviceFieldAggrBody,
  AggrDeviceFieldAggrResponse,
  AggrDeviceFieldThrBody,
  AggrDeviceFieldThrResponse,
  AggrDeviceResponseObj,
  AggrPlaysBody,
  AggrPlaysByAdResponse,
  AggrPlaysByDayResponse,
  AggrTotalPlaysByAdBody,
  AggrTotalPlaysByAdResponse,
  StatDeviceLogsBody,
  TabletRidesByDayBody,
  TabletRidesByDayResponse,
} from './types';

export const getDevice = (data: AggrDeviceBody)
  : Promise<void | AxiosResponse<AggrDeviceResponseObj []>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutesV2}`,
  url: `${ROUTES.STAT_AGGR}/device`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getDeviceXlsx = (data: AggrDeviceBody)
  : Promise<void | AxiosResponse<Blob>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.STAT_AGGR}/device-xlsx`,
  method: 'POST',
  responseType: 'blob',
  headers: {
    authorization: true,
  },
  data,
});

export const getDeviceCsv = (data: AggrDeviceBody)
  : Promise<void | AxiosResponse<Blob>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.STAT_AGGR}/device-csv`,
  method: 'POST',
  responseType: 'blob',
  headers: {
    authorization: true,
  },
  data,
});

export const getDeviceDayXlsx = (data: StatDeviceLogsBody)
  : Promise<void | AxiosResponse<Blob>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.STAT}/logs/device-day-xlsx`,
  method: 'POST',
  responseType: 'blob',
  headers: {
    authorization: true,
  },
  data,
});

export const getDeviceByField = (data: AggrDeviceFieldThrBody)
  : Promise<void | AxiosResponse<AggrDeviceFieldThrResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.STAT_AGGR}/device-field-thr`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getDeviceByAggr = (data: AggrDeviceFieldAggrBody)
  : Promise<void | AxiosResponse<AggrDeviceFieldAggrResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.STAT_AGGR}/device-field-aggr`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getPlaysByDay = (data: AggrPlaysBody)
  : Promise<void | AxiosResponse<AggrPlaysByDayResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.STAT_AGGR}/plays-by-day`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getPlaysByDayXlsx = (data: AggrDeviceBody)
  : Promise<void | AxiosResponse<Blob>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.STAT_AGGR}/plays-by-day-xlsx`,
  method: 'POST',
  responseType: 'blob',
  headers: {
    authorization: true,
  },
  data,
});

export const getPlaysByAd = (data: AggrPlaysBody)
  : Promise<void | AxiosResponse<AggrPlaysByAdResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutesV2}`,
  url: `${ROUTES.STAT_AGGR}/plays-by-ad`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getTotalPlaysByAd = (data: AggrTotalPlaysByAdBody)
  : Promise<void | AxiosResponse<AggrTotalPlaysByAdResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.STAT_AGGR}/total-plays-by-ad`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getTabletRidesByDay = (data: TabletRidesByDayBody)
  : Promise<void | AxiosResponse<TabletRidesByDayResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.STAT_AGGR}/tablet-rides-by-day`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});
